import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './event-list-button.css'

const EventListButton = ({ label, type }) => (
  <button styleName={`event-list-button-${type}`}>
    {label}
  </button>
)

EventListButton.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'secondary']).isRequired,
}

EventListButton.defaultProps = {
  type: 'primary',
}

export default CSSModules(EventListButton, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/event-list-button/event-list-button.js
 **/